const coreData = {
  filters: {
    dayFilter: function (value) {
        if (!value) return ''
        var days = {
          monday : 'Montag',
          tuesday : 'Dienstag',
          wednesday : 'Mittwoch',
          thursday : 'Donnerstag',
          friday : 'Freitag',
          saturday : 'Samstag',
          sunday : 'Sonntag',
        }
        value = days[value]
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
  data(){
    return {
      chatPartner: null,
      heartbeat: null,
      pop: false,
      labels: {
        de: {
          labelHours: 'Stunden',
          labelMinutes: 'Minuten',
          labelSeconds: 'Sekunden',
          labelIncrement: 'Erhöhen',
          labelDecrement: 'Verringern',
          labelSelected: 'Ausgewählte Zeit',
          labelNoTimeSelected: 'Keine Zeit ausgewählt'
        },
      },
      activeDays: 
        {
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,

        }
    }
  },
  computed: {
    URL(){
      return process.env.VUE_APP_API_BASEURL
  },
    kw(){
      return this.$store.getters.kw
    },
    adressData(){
      return this.$store.getters.adressData
    },
    lastMessage(){
      return this.$store.getters.lastMessage
    },
    connection(){
      return this.$store.getters.connection
    },
    updating(){
      return this.$store.getters.updating
    },
    authError(){
      return this.$store.getters.authError
    },
    authMessage(){
      return this.$store.getters.authMessage
    },
    loggedIn(){
      return this.$store.getters.loggedIn
    },
    chat(){
      return this.$store.getters.chat
    },
    chatId(){
      return this.$store.getters.chatId
    },
    userInformations(){
      return this.$store.getters.userInformations
    },
    companyFree(){
      return this.$store.getters.companyFree
    },
    states(){
      return this.$store.getters.states
    },
    countries(){
      return this.$store.getters.countries
    },
    company(){
      return this.$store.getters.company
    },
    daysOfWeek(){
      return this.getDaysOfWeek(this.getDateByWeek(this.kw[1] - 1, this.kw[2], 6))
    },
    shiftmodels(){
      return this.$store.getters.shiftmodels
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    departments(){
      return this.$store.getters.departments
    },
    shiftmodelCreated(){
      return this.$store.getters.shiftmodelCreated
    },
    users(){
      return this.$store.getters.users
    },
    shiftmodelUpdated(){
      return this.$store.getters.shiftmodelUpdated
    },
    creatingNewShift(){
      return this.$store.getters.creatingNewShift
    },
    accountCreated(){
      return this.$store.getters.accountCreated
    },
    loadingData(){
      return this.$store.getters.loadingData
    },
    departmentsOptions(){
      var array = []
        if(this.departments){
          this.departments.forEach(element => {
            array.push({value: element, text: element.title})
          });
        }
        return array
    },

    statesOptions(){
      var array = []
        if(this.states){
          this.states.forEach(element => {
            array.push({value: element, text: element.title})
          });
        }
        return array
    },
    countriesOptions(){
      var array = []
        if(this.countries){
          this.countries.forEach(element => {
            array.push({value: element, text: element.title})
          });
        }
        return array
    }
  },
  
  mounted() {

    if(this.$route.name != 'Home'){
      this.$store.dispatch('getCompany')
    }

    if(this.$route.name != 'Restaurant'){
      const descEl = document.querySelector('head meta[name="description"]');
      const titleEl = document.querySelector('head title');
      descEl.setAttribute('content', 'ᐅ Lecker Essen aus Deiner Region!');
      titleEl.textContent = 'ᐅ eatDorado | Oelsnitz'
    }

  },
  watch:{
    loggedIn(){
      if(this.loggedIn){
        this.$store.dispatch('getCompany')
        this.$store.dispatch('userInformations')
      }
    },
    
  },
  created(){

  },
  beforeDestroy(){
    clearInterval(this.heartbeat)
  },
  methods: {

    degreesToRadians(degrees) {
      return degrees * Math.PI / 180;
    },
    
    distanceInKmBetweenEarthCoordinates(lat1, lon1, lat2, lon2) {
      var earthRadiusKm = 6371;
    
      var dLat = this.degreesToRadians(lat2-lat1);
      var dLon = this.degreesToRadians(lon2-lon1);
    
      lat1 = this.degreesToRadians(lat1);
      lat2 = this.degreesToRadians(lat2);
    
      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

      if(lat1 && lon1 && lat2 && lon2){
        return (earthRadiusKm * c).toFixed(2) ;
      }else{
        return null
      }
      
    },

    getDaysOfWeek(current) {
      var week= new Array();
      current.setDate((current.getDate() - current.getDay() +1));
      for (var i = 0; i < 7; i++) {
          week.push(
              new Date(current)
          ); 
          current.setDate(current.getDate() +1);
      }
      return week;
    },
  
    getImage(link){
      return process.env.VUE_APP_API_BASEURL + '/' + link
    },
    getChatName(_id){
      var user = this.company.users.find(el => el._id == _id)
      if(user){ 
        return user.firstname + ' ' + user.lastname
      }
      return ''
    },
    keepalive(){
      if(this.connection){
        this.connection.send(JSON.stringify({heartbeat: true}))
      }else{
        this.connection = new WebSocket(process.env.VUE_APP_WEBSOCKET_BASEURL)
      }
       
    },
    getChatpartner(_id){
      this.$store.dispatch('getChats',{ _id: _id})
    },
    
    createURL(data){
      const objectURL = URL.createObjectURL(data)
      return objectURL
    },
    sendNotification(title, message, devices){
      var array = []
      devices.forEach(element => {
        if(element.deviceTokens){
          if(element.deviceTokens.length > 0){
            element.deviceTokens.forEach(deviceToken => {
              array.push(deviceToken.token)
            })
          }
        }
      })
      const payload = {
        title: title,
        message: message,
        devices: array,
        users: devices
      }
      this.$store.dispatch('postNotification', payload)
    },
    updateShiftmodelsDepartment(department){
      var array = []
      department.shiftmodels.forEach(element => {
        array.push(element._id)
      })
      this.$store.dispatch('updateShiftmodelsDepartment', {shiftmodels: array, _id: department._id})
    },
    checkShiftmodel(status, shiftmodel, department){
      if(status){
        department.shiftmodels.forEach((element, index) => {
          if(element._id == shiftmodel._id){
            department.shiftmodels.splice(index, 1)
          }
        })
      }else{
        department.shiftmodels.push(shiftmodel)
      }

      this.updateShiftmodelsDepartment(department)
    },
    getActiveShiftmodel(shiftmodel, department){
      if(this.company){
        var smodel = department.shiftmodels.find(el => el._id == shiftmodel._id)
        if(smodel){
          return true
        }
      }
      return false
    },
    getWeeksInMonth(month, year){
      var weeks = [],
          firstDate=new Date(year, month, 1),
          lastDate=new Date(year, month+1, 0), 
          numDays= lastDate.getDate();
      
      var start=1;
      var end=7-firstDate.getDay();
      while(start<=numDays){
        var date = new Date(year + '-' + ("0" + (month + 1)).slice(-2) + '-' + ("0" + end).slice(-2)+'T00:00')
        weeks.push(this.getWeekNumber(date));
          start = end + 1;
          end = end + 7;
          if(end>numDays)
              end=numDays;    
      }        
       return weeks;
   },
    getDateByWeek( weeks, year, day ) {
      var d = new Date(year, 0, 1);
      var dayNum = d.getDay();
      var requiredDate = --weeks * 7;
      // If 1 Jan is Friday to Sunday, go to next week 
      if (((dayNum!=0) || dayNum > 4)) {
          requiredDate += 7;
        }
      // Add required number of days
      if(day == 0){
        d.setDate(day - d.getDay() + requiredDate + 8 );
      }else{
        d.setDate(day - d.getDay() + ++requiredDate );
      }
      
      return d;
    },
    makeToast(append, title, content, variant) {
      this.$bvToast.toast(content, {
        title: title,
        autoHideDelay: 1000,
        appendToast: append,
        variant: variant
        }
      )
    },
    getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      return days;
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const bandA = a.shiftModel.start;
      const bandB = b.shiftModel.start;
    
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    
    getPlannedShifts(department){
      var dep = this.company.departments.find(el => el._id == department._id)
      var peak = 0
      if(this.kw){
        peak = this.kw[1];
         dep.shifts.forEach(element => {
           if(element.week){
             if(element.week.year >= this.kw[0] && element.week.week >= this.kw[1]){
                 if(element.week.week > peak){
                   peak = element.week.week
                 }
               }
           }
         });
      }
      
      return peak
     },
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
      // Return array of year and week number
      return [d.getUTCFullYear(), weekNo, d.getMonth() + 1, d ];
    },
    parseEmoji: function (string) {

      this.outHtml = this.$twemoji.parse(string, function (emoji, options) {
        return options.base + emoji + options.extension
        
      })
    },
    scrollToTop(){
      var myDiv = document.getElementById('scroll-container');
      myDiv.scrollTo({top: 0, behavior: 'smooth'});
    },
    windowOpen(link){
      window.open(link, "_blank")
    },
  }
}

export default coreData